import { forwardRef, type SVGProps, useId } from "react";

export const SingPlusIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width="30"
        height="18"
        viewBox="0 0 30 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={ariaHidden}
        {...props}
      >
        <title>Sing+</title>
        <path
          d="M11.6865 6.85742C12.3645 6.29979 12.8012 6.36661 13.2676 7.08203C13.8068 7.90914 14.315 8.75733 14.8662 9.57617C15.1889 10.0558 15.1533 10.4334 14.7471 10.8506C13.9276 11.6921 13.1422 12.5667 12.3027 13.4678C11.0444 14.8184 9.84496 16.1474 8.5918 17.4238C8.32977 17.6907 7.85871 17.9215 7.50098 17.8994C5.39307 17.7691 3.2877 17.5788 1.1875 17.3545C0.871591 17.3206 0.423545 17.057 0.335938 16.7988C0.257076 16.5655 0.507466 16.099 0.749023 15.8975C4.38082 12.8676 8.03384 9.86236 11.6865 6.85742ZM25.6357 8.47168H30V10.1719H25.6357V14.5547H23.9219V10.1719H19.5576V8.47168H23.9219V4.1123H25.6357V8.47168ZM7.63672 0.00292969C9.71571 0.161671 11.7923 0.359352 13.8643 0.592773C14.185 0.628903 14.6983 0.883476 14.7295 1.09473C14.7737 1.39503 14.5369 1.84648 14.2773 2.06445C11.5151 4.38397 8.72411 6.67001 5.89746 9.00195C5.00954 9.73689 4.17515 10.4475 3.31836 11.1299C2.70038 11.622 2.27765 11.5546 1.84766 10.9053C1.28802 10.0602 0.763027 9.1923 0.207031 8.34473C-0.0823368 7.90362 -0.0827836 7.53349 0.296875 7.12793C2.41386 4.86676 4.50559 2.58181 6.63965 0.336914C6.85605 0.109272 7.30907 -0.0220882 7.63672 0.00292969Z"
          fill="currentColor"
        />
      </svg>
    );
  },
);
SingPlusIcon.displayName = "SingPlusIcon";

export const SingPlusWordLogoIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
  const uid = useId().replace(/:/g, "");
  const maskId = `mask${uid}`;
  const clipId = `clip${uid}`;
  const paint0Id = `p0${uid}`;
  const paint1Id = `p1${uid}`;
  const paint2Id = `p2${uid}`;
  const paint3Id = `p3${uid}`;
  return (
    <svg
      ref={ref}
      width="158"
      height="32"
      viewBox="0 0 158 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaHidden}
      {...props}
    >
      <title>Sing+ wordmark</title>
      <g clipPath={`url(#${clipId})`}>
        <mask
          id={maskId}
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="87"
          height="32"
        >
          <path d="M86.1818 0H0V32H86.1818V0Z" fill="white" />
        </mask>
        <g mask={`url(#${maskId})`}>
          <path
            d="M70.7777 20.5208C68.7896 16.761 69.4193 12.3763 72.2617 9.86085C74.8882 7.53667 78.7027 7.34715 81.5589 9.39683C81.7076 9.50353 81.8688 9.59284 82.1495 9.76896C82.0589 8.70579 82.6056 8.39616 83.4446 8.38384C83.7618 8.3792 84.0781 8.30313 84.3942 8.25686C85.9503 8.02918 85.9557 8.02886 85.9519 9.56521C85.9398 14.414 85.8975 19.2629 85.9171 24.1115C85.9316 27.6678 83.3746 31.0834 78.6831 31.5714C75.8131 31.8699 73.1338 31.3322 70.9001 29.3315C69.7216 28.2758 69.725 28.2205 70.8343 27.1069C72.0966 25.8398 72.0795 25.864 73.5529 26.9104C75.4103 28.2296 77.465 28.4448 79.5861 27.7334C81.2906 27.1619 82.1833 25.797 82.2057 23.988C82.2118 23.4842 82.2065 22.9803 82.2065 22.2494C80.031 24.1837 77.6628 24.5683 75.1086 23.9088C73.2184 23.4208 71.8296 22.2323 70.7777 20.5208ZM73.6501 14.4997C73.5988 14.7511 73.5401 15.0011 73.4977 15.2539C72.8891 18.8813 75.9483 21.5691 79.4525 20.4875C81.5063 19.8534 82.5693 18.0981 82.427 15.5746C82.3137 13.5638 80.8962 11.9127 79.0042 11.5877C76.508 11.159 74.6581 12.1267 73.6501 14.4997Z"
            fill="white"
          />
          <path
            d="M62.5598 12.5932C61.2621 11.3163 59.7795 11.1737 58.2498 11.7898C56.6991 12.4142 56.1297 13.7523 56.1204 15.35C56.1046 18.0783 56.0923 20.8071 56.1303 23.5351C56.1409 24.2999 55.894 24.5879 55.1367 24.522C54.5653 24.4723 53.9831 24.4748 53.4113 24.5214C52.6532 24.5831 52.4167 24.2811 52.422 23.5257C52.4512 19.3851 52.4358 15.2441 52.4358 11.1032C52.4358 8.95401 52.4358 8.95401 54.5315 8.60132C55.9817 8.35729 55.9817 8.35729 56.2331 9.82791C56.4613 9.68276 56.6717 9.57094 56.8578 9.42742C58.9138 7.84134 61.1846 7.45658 63.5183 8.57146C65.9049 9.71162 67.1713 11.7408 67.2148 14.4186C67.2634 17.4351 67.2039 20.4534 67.2408 23.4703C67.2505 24.2577 67.0161 24.5305 66.2104 24.5292C63.5461 24.5254 63.5461 24.5535 63.5461 21.8572C63.5461 19.7387 63.5468 17.6201 63.5455 15.5015C63.5448 14.4468 63.3303 13.4616 62.5598 12.5932Z"
            fill="white"
          />
          <path
            d="M42.823 18.6007C42.9823 22.0188 41.3881 23.9392 37.9628 24.3903C35.3384 24.7357 32.9577 24.0879 30.902 22.3464C30.2931 21.8306 30.0823 21.3652 30.8169 20.8084C30.8675 20.7701 30.909 20.7194 30.954 20.6738C32.2638 19.3514 32.2565 19.3632 33.8031 20.3236C35.156 21.1637 36.6543 21.2956 38.1497 20.9324C38.6082 20.821 39.2338 20.2456 39.2685 19.8388C39.3082 19.3725 38.8925 18.641 38.4667 18.4084C37.5823 17.9253 36.5609 17.6951 35.5955 17.3623C35.0218 17.1647 34.4362 16.9972 33.8751 16.7687C32.0313 16.0176 31.0073 14.6758 31.0245 12.6327C31.0421 10.5663 31.9713 9.07925 33.8736 8.2422C36.5204 7.07772 40.2007 7.699 42.1436 9.58802C42.7135 10.1422 42.8926 10.611 42.175 11.1516C42.0485 11.2471 41.9458 11.3749 41.8327 11.4883C40.7141 12.6103 40.7232 12.596 39.4214 11.7657C38.2565 11.0227 36.9692 10.7798 35.6586 11.2123C35.2249 11.3554 34.6689 11.8581 34.6244 12.2487C34.5802 12.6358 35.0168 13.2987 35.4061 13.4732C36.5365 13.9797 37.7552 14.2841 38.9276 14.7008C40.8047 15.3679 42.4483 16.2916 42.823 18.6007Z"
            fill="white"
          />
          <path
            d="M8.15193 16.4676C7.09045 17.3519 6.09287 18.2066 5.06861 19.0277C4.32981 19.62 3.82487 19.5392 3.31084 18.7578C2.64176 17.7407 2.01367 16.6965 1.34894 15.6766C1.00302 15.1458 1.00342 14.7009 1.45732 14.2129C3.98786 11.4921 6.48753 8.74223 9.0385 6.04101C9.29717 5.76711 9.83839 5.6093 10.2301 5.6394C12.7154 5.83042 15.1981 6.06786 17.675 6.34876C18.0583 6.39223 18.6722 6.69856 18.7093 6.95276C18.7623 7.3141 18.4787 7.85748 18.1683 8.11983C14.8665 10.9108 11.5308 13.6616 8.15193 16.4676Z"
            fill="white"
          />
          <path
            d="M15.8073 21.8398C14.3032 23.465 12.8696 25.064 11.3717 26.5998C11.0584 26.921 10.4959 27.1992 10.0682 27.1726C7.54852 27.0158 5.03218 26.7869 2.52169 26.517C2.14406 26.4765 1.60762 26.1595 1.50287 25.8488C1.40824 25.5682 1.70887 25.0069 1.99774 24.7642C6.339 21.1186 10.7049 17.5022 15.0711 13.8866C15.8817 13.2153 16.4034 13.2956 16.961 14.1565C17.6055 15.1518 18.2127 16.1717 18.8715 17.1571C19.2578 17.7344 19.2155 18.1886 18.7298 18.6907C17.7501 19.7034 16.8108 20.7555 15.8073 21.8398Z"
            fill="white"
          />
          <path
            d="M45.5525 23.4657C45.5524 18.7558 45.5733 14.1366 45.5348 9.51776C45.5272 8.60353 45.7872 8.28593 46.7253 8.30131C49.2675 8.34299 49.2681 8.30456 49.2681 10.84C49.2681 15.01 49.2427 19.1803 49.2873 23.3499C49.2973 24.2864 49.0065 24.6331 48.0863 24.5249C47.5818 24.4657 47.0617 24.4789 46.5542 24.5227C45.8231 24.5857 45.4493 24.3358 45.5525 23.4657Z"
            fill="white"
          />
          <path
            d="M45.2363 3.10113C45.4625 1.54385 46.2284 0.853145 47.5678 0.92386C48.6841 0.982787 49.472 1.74388 49.5724 2.85991C49.6865 4.12909 48.9914 5.09559 47.808 5.32708C46.7062 5.54258 45.1919 4.74357 45.2363 3.10113Z"
            fill="white"
          />
        </g>
        <path
          d="M92.5657 6.84766H101.471C102.233 6.84766 102.95 6.91806 103.622 7.05886C104.299 7.19538 104.918 7.39593 105.48 7.66046C106.046 7.92073 106.553 8.24073 107 8.62046C107.446 8.99593 107.825 9.42258 108.136 9.90046C108.451 10.3783 108.689 10.901 108.851 11.4685C109.017 12.0317 109.1 12.6354 109.1 13.2797C109.1 14.2439 108.917 15.1229 108.551 15.9165C108.185 16.7058 107.668 17.382 107 17.9452C106.331 18.5084 105.529 18.9436 104.593 19.2508C103.656 19.558 102.616 19.7116 101.471 19.7116H98.6303V25.1516H92.5657V6.84766ZM101.248 15.1037C101.835 15.1037 102.28 14.9501 102.582 14.6429C102.884 14.3357 103.035 13.8834 103.035 13.2861C103.035 12.6845 102.884 12.2301 102.582 11.9229C102.28 11.6114 101.835 11.4557 101.248 11.4557H98.6303V15.1037H101.248Z"
          fill={`url(#${paint0Id})`}
        />
        <path
          d="M115.912 6.84766V20.2876H122.564V25.1516H109.847V6.84766H115.912Z"
          fill={`url(#${paint1Id})`}
        />
        <path
          d="M122.939 6.84766H129.004V17.4076C129.004 18.0263 129.048 18.5426 129.138 18.9564C129.227 19.366 129.361 19.6946 129.54 19.942C129.723 20.1852 129.95 20.358 130.223 20.4604C130.495 20.5586 130.812 20.6076 131.174 20.6076C131.54 20.6076 131.857 20.5586 132.125 20.4604C132.398 20.358 132.623 20.1852 132.802 19.942C132.985 19.6946 133.121 19.366 133.21 18.9564C133.3 18.5426 133.345 18.0263 133.345 17.4076V6.84766H139.409V18.1116C139.409 18.9351 139.313 19.6903 139.122 20.3772C138.935 21.0642 138.666 21.6828 138.317 22.2332C137.969 22.7836 137.547 23.2658 137.053 23.6796C136.56 24.0935 136.009 24.4391 135.4 24.7164C134.791 24.9895 134.13 25.1943 133.415 25.3308C132.704 25.4674 131.957 25.5356 131.174 25.5356C130.391 25.5356 129.642 25.4674 128.927 25.3308C128.216 25.1943 127.556 24.9895 126.948 24.7164C126.339 24.4391 125.788 24.0935 125.294 23.6796C124.801 23.2658 124.379 22.7836 124.031 22.2332C123.681 21.6828 123.411 21.0642 123.22 20.3772C123.032 19.6903 122.939 18.9351 122.939 18.1116V6.84766Z"
          fill={`url(#${paint2Id})`}
        />
        <path
          d="M148.823 6.46387C150.122 6.46387 151.279 6.6132 152.296 6.91187C153.318 7.20627 154.179 7.63507 154.882 8.19827C155.584 8.76147 156.12 9.4484 156.49 10.2591C156.861 11.0655 157.046 11.9807 157.046 13.0047H151.3C151.3 12.6975 151.241 12.4244 151.122 12.1855C151.007 11.9423 150.839 11.7375 150.617 11.5711C150.396 11.4004 150.126 11.2703 149.806 11.1807C149.492 11.0911 149.132 11.0463 148.728 11.0463C148.396 11.0463 148.094 11.0761 147.821 11.1359C147.553 11.1913 147.321 11.2724 147.125 11.3791C146.93 11.4857 146.778 11.6116 146.672 11.7567C146.566 11.8975 146.512 12.0553 146.512 12.2303C146.512 12.4521 146.568 12.6335 146.678 12.7743C146.793 12.9108 146.976 13.026 147.227 13.1199C147.479 13.2095 147.806 13.2884 148.211 13.3567C148.615 13.4207 149.111 13.4953 149.698 13.5807L150.138 13.6447C150.513 13.6959 150.907 13.7556 151.319 13.8239C151.732 13.8879 152.147 13.9689 152.564 14.0671C152.986 14.1609 153.401 14.2761 153.809 14.4127C154.222 14.5492 154.614 14.7156 154.984 14.9119C155.354 15.1081 155.697 15.3407 156.012 15.6095C156.331 15.8783 156.605 16.1918 156.835 16.5502C157.069 16.9086 157.252 17.3182 157.384 17.779C157.516 18.2356 157.582 18.754 157.582 19.3342C157.582 20.3113 157.388 21.1838 157.001 21.9518C156.614 22.7198 156.05 23.3705 155.309 23.9038C154.569 24.4329 153.66 24.8382 152.583 25.1198C151.507 25.3972 150.281 25.5358 148.906 25.5358C147.459 25.5358 146.191 25.3822 145.102 25.075C144.012 24.7678 143.103 24.3262 142.376 23.7502C141.648 23.17 141.101 22.466 140.735 21.6382C140.369 20.8062 140.186 19.8697 140.186 18.8286H145.931C145.931 19.1657 145.998 19.4665 146.129 19.731C146.266 19.9913 146.459 20.2132 146.71 20.3966C146.966 20.5758 147.276 20.7145 147.642 20.8126C148.008 20.9065 148.425 20.9534 148.894 20.9534C149.289 20.9534 149.649 20.9214 149.972 20.8574C150.296 20.7892 150.573 20.6974 150.802 20.5822C151.032 20.4628 151.211 20.322 151.339 20.1598C151.466 19.9934 151.53 19.8121 151.53 19.6158C151.53 19.3769 151.471 19.187 151.351 19.0462C151.236 18.9054 151.049 18.7902 150.79 18.7006C150.53 18.6068 150.194 18.53 149.781 18.4702C149.368 18.4062 148.868 18.338 148.281 18.2654L147.642 18.1822C147.289 18.1396 146.915 18.0905 146.519 18.035C146.127 17.9796 145.729 17.9092 145.325 17.8238C144.921 17.7385 144.519 17.6318 144.118 17.5038C143.723 17.3758 143.344 17.218 142.982 17.0302C142.621 16.8425 142.284 16.6206 141.974 16.3646C141.667 16.1044 141.399 15.8015 141.169 15.4559C140.944 15.106 140.765 14.7071 140.633 14.2591C140.505 13.8068 140.441 13.2969 140.441 12.7295C140.441 11.7225 140.644 10.8308 141.048 10.0543C141.456 9.27774 142.029 8.62279 142.765 8.08947C143.506 7.55614 144.389 7.15294 145.414 6.87987C146.444 6.60254 147.581 6.46387 148.823 6.46387Z"
          fill={`url(#${paint3Id})`}
        />
      </g>
      <defs>
        <linearGradient
          id={paint0Id}
          x1="89.6915"
          y1="4.47699"
          x2="150.279"
          y2="42.7613"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4285F3" />
          <stop offset="1" stopColor="#F48A4D" />
        </linearGradient>
        <linearGradient
          id={paint1Id}
          x1="89.6916"
          y1="4.47698"
          x2="150.279"
          y2="42.7612"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4285F3" />
          <stop offset="1" stopColor="#F48A4D" />
        </linearGradient>
        <linearGradient
          id={paint2Id}
          x1="89.6915"
          y1="4.47698"
          x2="150.279"
          y2="42.7612"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4285F3" />
          <stop offset="1" stopColor="#F48A4D" />
        </linearGradient>
        <linearGradient
          id={paint3Id}
          x1="89.6915"
          y1="4.4772"
          x2="150.279"
          y2="42.7615"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4285F3" />
          <stop offset="1" stopColor="#F48A4D" />
        </linearGradient>
        <clipPath id={clipId}>
          <rect width="158" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});
SingPlusWordLogoIcon.displayName = "SingPlusWordLogoIcon";

export const FullLogoIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width="105"
        height="40"
        viewBox="0 0 105 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={ariaHidden}
        {...props}
      >
        <title>Worship Devo logo</title>
        <path
          d="M85.4859 25.3941C83.1051 20.9079 83.8593 15.6762 87.2632 12.6749C90.4083 9.90168 94.9763 9.67556 98.3966 12.1212C98.5746 12.2485 98.7676 12.3551 99.1039 12.5652C98.9954 11.2967 99.6501 10.9272 100.655 10.9125C101.035 10.907 101.413 10.8162 101.792 10.761C103.655 10.4893 103.662 10.489 103.657 12.3221C103.643 18.1076 103.592 23.8931 103.616 29.6784C103.633 33.9219 100.571 37.9972 94.9528 38.5795C91.5159 38.9357 88.3074 38.2941 85.6325 35.9068C84.2212 34.6473 84.2253 34.5812 85.5537 33.2525C87.0652 31.7407 87.0448 31.7695 88.8093 33.0181C91.0335 34.592 93.4941 34.8489 96.034 34.0002C98.0753 33.3181 99.1444 31.6896 99.171 29.531C99.1784 28.93 99.1722 28.3288 99.1722 27.4566C96.567 29.7645 93.7309 30.2235 90.6723 29.4367C88.4086 28.8543 86.7456 27.4362 85.4859 25.3941ZM88.9256 18.2099C88.8643 18.5098 88.7939 18.8081 88.7431 19.1098C88.0144 23.4379 91.6778 26.6449 95.8742 25.3543C98.3337 24.5979 99.6065 22.5033 99.4362 19.4924C99.3004 17.0931 97.603 15.1231 95.3373 14.7353C92.3481 14.2237 90.1327 15.3784 88.9256 18.2099Z"
          fill="#FEFAF0"
        />
        <path
          d="M75.6448 15.9347C74.0907 14.4111 72.3154 14.241 70.4835 14.9761C68.6266 15.7212 67.9445 17.3178 67.9335 19.224C67.9146 22.4795 67.9 25.7355 67.9453 28.9904C67.958 29.903 67.6624 30.2466 66.7555 30.168C66.0713 30.1086 65.3741 30.1116 64.6892 30.1672C63.7815 30.2409 63.4982 29.8805 63.5046 28.9791C63.5396 24.0386 63.5212 19.0977 63.5212 14.1569C63.5211 11.5925 63.5212 11.5925 66.0308 11.1717C67.7674 10.8805 67.7674 10.8805 68.0684 12.6352C68.3418 12.462 68.5937 12.3286 68.8165 12.1574C71.2787 10.2649 73.9979 9.80579 76.7926 11.1361C79.6507 12.4965 81.1672 14.9176 81.219 18.1127C81.2774 21.712 81.2062 25.3134 81.2503 28.9131C81.2619 29.8526 80.9813 30.178 80.0164 30.1766C76.8259 30.1719 76.8259 30.2055 76.8259 26.9884C76.8258 24.4605 76.8267 21.9327 76.8252 19.4049C76.8244 18.1463 76.5674 16.9708 75.6448 15.9347Z"
          fill="#FEFAF1"
        />
        <path
          d="M52.0097 23.1031C52.2004 27.1815 50.2915 29.473 46.1896 30.011C43.0469 30.4233 40.196 29.6504 37.7341 27.5724C37.0051 26.957 36.7525 26.4016 37.6324 25.7373C37.693 25.6915 37.7426 25.6311 37.7966 25.5768C39.365 23.9989 39.3562 24.013 41.2082 25.1589C42.8284 26.1613 44.6226 26.3186 46.4135 25.8853C46.9625 25.7524 47.7117 25.0659 47.7532 24.5803C47.8006 24.024 47.303 23.1512 46.793 22.8736C45.7341 22.2973 44.5109 22.0225 43.3547 21.6255C42.6677 21.3896 41.9664 21.1898 41.2945 20.9171C39.0865 20.021 37.8602 18.42 37.881 15.9822C37.902 13.5166 39.0146 11.7423 41.2928 10.7435C44.4623 9.35409 48.8695 10.0954 51.1961 12.3493C51.8786 13.0106 52.093 13.5699 51.2339 14.215C51.0822 14.3289 50.9594 14.4814 50.8239 14.6168C49.4842 15.9555 49.4952 15.9384 47.9363 14.9477C46.5412 14.0611 44.9996 13.7714 43.4303 14.2874C42.9109 14.4582 42.2451 15.058 42.1918 15.5241C42.1389 15.9859 42.6618 16.7768 43.128 16.985C44.4816 17.5895 45.9409 17.9527 47.3449 18.4498C49.5929 19.2457 51.5609 20.3479 52.0097 23.1031Z"
          fill="#FDFAF0"
        />
        <path
          d="M10.4892 20.5578C9.21808 21.6131 8.02344 22.6328 6.79689 23.6126C5.91217 24.3193 5.30749 24.2229 4.69193 23.2905C3.89071 22.077 3.13855 20.8311 2.34253 19.6141C1.92829 18.9807 1.92876 18.45 2.47232 17.8677C5.50268 14.6213 8.49607 11.3401 11.5509 8.11709C11.8606 7.79026 12.5088 7.60197 12.9778 7.63789C15.9541 7.86581 18.927 8.14912 21.8932 8.48429C22.3522 8.53616 23.0872 8.90167 23.1319 9.20496C23.1953 9.63611 22.8557 10.2845 22.484 10.5975C18.5299 13.9277 14.5354 17.2098 10.4892 20.5578Z"
          fill="#FEFAF0"
        />
        <path
          d="M19.6572 26.9686C17.856 28.9077 16.1393 30.8157 14.3454 32.6482C13.9704 33.0314 13.2966 33.3633 12.7846 33.3316C9.76717 33.1445 6.75384 32.8714 3.74748 32.5494C3.29526 32.5009 2.65288 32.1228 2.52743 31.7521C2.41411 31.4171 2.77411 30.7474 3.12004 30.4579C8.31876 26.1079 13.547 21.7931 18.7756 17.4789C19.7462 16.678 20.3711 16.7738 21.0387 17.801C21.8105 18.9885 22.5376 20.2056 23.3267 21.3812C23.7891 22.0701 23.7386 22.612 23.1569 23.2111C21.9837 24.4194 20.859 25.6748 19.6572 26.9686Z"
          fill="#FEFAF1"
        />
        <path
          d="M55.2788 28.9071C55.2786 23.2873 55.3035 17.7757 55.2575 12.2646C55.2483 11.1738 55.5597 10.7948 56.6831 10.8131C59.7274 10.8629 59.7282 10.817 59.7282 13.8423C59.7281 18.8179 59.6977 23.7938 59.7512 28.7689C59.7632 29.8862 59.4149 30.3 58.313 30.1709C57.7089 30.1002 57.086 30.1158 56.4782 30.1681C55.6028 30.2435 55.1551 29.9452 55.2788 28.9071Z"
          fill="#FDF9EF"
        />
        <path
          d="M54.8999 4.60858C55.1707 2.75046 56.0878 1.92633 57.6918 2.0107C59.0285 2.08101 59.9722 2.98914 60.0923 4.32075C60.2289 5.83513 59.3966 6.98832 57.9794 7.26453C56.66 7.52168 54.8468 6.56832 54.8999 4.60858Z"
          fill="#FDF9EF"
        />
      </svg>
    );
  },
);
FullLogoIcon.displayName = "FullLogoIcon";

export const LogoWhiteIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width="96"
        height="96"
        viewBox="0 0 96 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={ariaHidden}
        {...props}
      >
        <title>Worship Devo logo</title>
        <g clipPath="url(#clip0_5_2)">
          <mask
            id="mask0_5_2"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="2"
            y="2"
            width="92"
            height="92"
          >
            <path d="M94 2H2V94H94V2Z" fill="white" />
          </mask>
          <g mask="url(#mask0_5_2)">
            <path
              d="M40.7835 48.2275C36.8855 51.4638 33.222 54.5909 29.4606 57.5953C26.7474 59.7625 24.8931 59.4669 23.0053 56.6078C20.5482 52.8864 18.2416 49.0657 15.8005 45.3332C14.5302 43.3911 14.5316 41.7633 16.1985 39.9776C25.4916 30.0221 34.6713 19.9599 44.0394 10.0759C44.9895 9.0737 46.977 8.49624 48.4152 8.6064C57.5425 9.30538 66.6598 10.1742 75.7558 11.202C77.1637 11.3611 79.4177 12.482 79.5545 13.4121C79.7492 14.7343 78.7075 16.7226 77.5679 17.6825C65.442 27.8951 53.1922 37.9603 40.7835 48.2275Z"
              fill="white"
            />
            <path
              d="M68.8999 67.8876C63.3763 73.8339 58.1117 79.6851 52.6107 85.3051C51.4604 86.4799 49.3944 87.4981 47.824 87.4005C38.5706 86.8271 29.3297 85.9896 20.1102 85.0018C18.7234 84.8534 16.7534 83.6939 16.3687 82.5567C16.0212 81.5297 17.1252 79.476 18.1861 78.5882C34.1289 65.2482 50.162 52.0161 66.1964 38.7859C69.1732 36.3298 71.0892 36.6233 73.1369 39.7737C75.5037 43.4153 77.7335 47.1475 80.1531 50.753C81.5711 52.8656 81.4162 54.5274 79.6324 56.3646C76.0345 60.0701 72.5858 63.9197 68.8999 67.8876Z"
              fill="white"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_5_2">
            <rect
              width="92"
              height="92"
              fill="white"
              transform="translate(2 2)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  },
);
LogoWhiteIcon.displayName = "LogoWhiteIcon";

export const LogoDarkIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={ariaHidden}
        {...props}
      >
        <title>Worship Devo logo</title>
        <g clipPath="url(#clip0_10_4418)">
          <path
            d="M13.3754 15.0742C12.1043 16.1295 10.9096 17.1492 9.68307 18.1289C8.79835 18.8356 8.19367 18.7392 7.57812 17.8069C6.77689 16.5934 6.02473 15.3475 5.22871 14.1304C4.81447 13.4971 4.81495 12.9663 5.3585 12.384C8.38886 9.13763 11.3823 5.8565 14.4371 2.63346C14.7468 2.30664 15.395 2.11834 15.864 2.15426C18.8402 2.38219 21.8132 2.6655 24.7793 3.00066C25.2384 3.05253 25.9734 3.41804 26.0181 3.72133C26.0815 4.15249 25.7419 4.80084 25.3702 5.11386C21.4161 8.44404 17.4216 11.7262 13.3754 15.0742Z"
            fill="currentColor"
          />
          <path
            d="M22.5438 21.4851C20.7425 23.4241 19.0258 25.3321 17.232 27.1647C16.8569 27.5478 16.1832 27.8798 15.6711 27.848C12.6537 27.661 9.64041 27.3879 6.63405 27.0658C6.18182 27.0174 5.53945 26.6393 5.414 26.2685C5.30068 25.9336 5.66068 25.2639 6.00661 24.9744C11.2053 20.6244 16.4335 16.3096 21.6621 11.9954C22.6328 11.1945 23.2576 11.2902 23.9253 12.3175C24.6971 13.505 25.4242 14.722 26.2133 15.8977C26.6757 16.5866 26.6252 17.1285 26.0434 17.7276C24.8702 18.9359 23.7456 20.1912 22.5438 21.4851Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_10_4418">
            <rect
              width="30"
              height="30"
              fill="black"
              transform="translate(0.728516)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  },
);
LogoDarkIcon.displayName = "LogoDarkIcon";

export const SingPlusGradientIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
  const uid = useId().replace(/:/g, "");
  const paint0Id = `paint0${uid}`;
  const paint1Id = `paint1${uid}`;
  return (
    <svg
      ref={ref}
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaHidden}
      {...props}
    >
      <title>Sing+ Gradient</title>
      <path
        d="M5.47537 8.04642C4.65099 8.7034 3.87622 9.33825 3.08076 9.94823C2.50698 10.3882 2.11483 10.3282 1.71561 9.74775C1.19599 8.99222 0.708185 8.21657 0.19193 7.45884C-0.0767194 7.06454 -0.076411 6.73411 0.276105 6.37157C2.24141 4.35042 4.18274 2.30765 6.1639 0.301056C6.3648 0.0975799 6.78514 -0.0196472 7.08931 0.00271484C9.01954 0.144615 10.9476 0.320999 12.8713 0.529666C13.169 0.56196 13.6457 0.789519 13.6746 0.978343C13.7158 1.24677 13.4955 1.65042 13.2545 1.84531C10.6901 3.91861 8.0995 5.96202 5.47537 8.04642Z"
        fill={`url(#${paint0Id})`}
      />
      <path
        d="M11.4185 12.0372C10.2503 13.2444 9.13697 14.4323 7.9736 15.5732C7.73035 15.8118 7.29343 16.0185 6.96131 15.9987C5.00442 15.8822 3.05016 15.7122 1.10042 15.5117C0.807129 15.4815 0.390522 15.2461 0.309166 15.0153C0.235669 14.8068 0.469146 14.3898 0.693497 14.2096C4.06507 11.5014 7.45576 8.81507 10.8467 6.12913C11.4762 5.63049 11.8815 5.69012 12.3145 6.32968C12.815 7.06899 13.2866 7.8267 13.7983 8.55862C14.0982 8.98751 14.0654 9.32491 13.6882 9.69791C12.9273 10.4501 12.1979 11.2317 11.4185 12.0372Z"
        fill={`url(#${paint1Id})`}
      />
      <defs>
        <linearGradient
          id={paint0Id}
          x1="-0.618878"
          y1="-1.66667"
          x2="17.1686"
          y2="1.21825"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4285F3" />
          <stop offset={1} stopColor="#F48A4D" />
        </linearGradient>
        <linearGradient
          id={paint1Id}
          x1="-0.618878"
          y1="-1.66667"
          x2="17.1686"
          y2="1.21825"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4285F3" />
          <stop offset={1} stopColor="#F48A4D" />
        </linearGradient>
      </defs>
    </svg>
  );
});
SingPlusGradientIcon.displayName = "SingPlusGradientIcon";
